module.exports = __webpack_public_path__ + "img/img_landing_flash2.5cc47613.png";